import {useCallback} from "react";
import {useAppDispatch} from "@/store/store.ts";
import {setLoggedOut} from "@/store/auth/thunks/setLoggedOut.ts";

export default function LogoutButton() {

	const dispatch = useAppDispatch()
	const logout = useCallback(() => {
		dispatch(setLoggedOut())
	}, [])

	return (
			<button
				type="submit"
				onClick={logout}
				className={
					'border-none bg-transparent uppercase cursor-pointer font-TelstraText text-base py-[20px] pl-[7px] pr-[7px] text-white hover:text-colourSky80 focus:outline-none focus:text-colourSky80'
				}
			>
				Logout
			</button>
	)
}
